export default "__VITE_ASSET__BI9SGtk3__"